import { Injectable, OnDestroy } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { CaasContentService } from '../services/caas-content.service';
import { MetaDataService } from '../services/meta-data.service';

@Injectable({
  providedIn: 'root',
})
export class RouteDataGuard implements CanActivate, OnDestroy {
  private metaDataSubscription$: Subscription = new Subscription();
  constructor(
    private caasContentService: CaasContentService,
    private metaDataService: MetaDataService
  ) {}
  canActivate(
    next: ActivatedRouteSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const routeData = next.data;
    this.metaDataSubscription$ = this.caasContentService
      .getContent(routeData['pageIdentifier'])
      .subscribe((data) => {
        this.metaDataService.setMetaData(data.metaData);
      });
    return true;
  }

  ngOnDestroy(): void {
    this.metaDataSubscription$.unsubscribe();
  }
}
